<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important; font-weight: 400; color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Partner Reports</h5>
  </div>

  <div class="container">
    <div class="modal-body">

      <div class="row g-4">

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Budget')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="budgetClick()">Budget</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Overtime Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="overtimeReportClick()">Overtime Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Independence Declaration')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="independenceDeclarationClick()">Independence Declaration</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Variance Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="varianceReportClick()">Variance Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Variance Report Summary')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="varianceReportSummaryClick()">Variance Report Summary</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Article Debit Credit Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="articleDebitCreditReportClick()">Article Debit Credit Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Actual Task Summary Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="actualTaskSummaryReportClick()">Actual Task Summary Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Announcement History')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="manageAnnouncementClick()">Announcement History</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Diary Report - Client Wise')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="diaryReportClientWiseClick()">Diary Report - Client Wise</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('MIS Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="misReportClick()">MIS Report</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>